import { BankAccountStatus, PaymentMethod, PayoutInterval } from "../enums";
import { Day } from "../enums/dates";
import { getDateMinusNDays } from "./dates";
export const StripeMonthlyAnchor = 3;
export const StripeWeeklyAnchor = Day.Monday;
export const CharityMCC = 8398;
const day = {
    [Day.Monday]: 1,
    [Day.Tuesday]: 2,
    [Day.Wednesday]: 3,
    [Day.Thursday]: 4,
    [Day.Friday]: 5,
    [Day.Saturday]: 6,
    [Day.Sunday]: 7,
};
const payoutWeekklyAnchorNumber = day[StripeWeeklyAnchor];
export const getNextPayoutDate = (date, interval, lastPayoutCreatedAtUtc) => {
    if (interval === PayoutInterval.Monthly) {
        if (date.getDate() <= StripeMonthlyAnchor &&
            (!lastPayoutCreatedAtUtc || lastPayoutCreatedAtUtc < getDateMinusNDays(date, StripeMonthlyAnchor))) {
            return new Date(date.getFullYear(), date.getMonth(), StripeMonthlyAnchor, 12);
        }
        else {
            return new Date(date.getFullYear(), date.getMonth() + 1, StripeMonthlyAnchor, 12);
        }
    }
    if (interval === PayoutInterval.Weekly) {
        const baseDate = new Date(date);
        const offset = (payoutWeekklyAnchorNumber + 7 - baseDate.getDay()) % 7;
        const daysToAdd = offset === 0 ? 0 : offset; // default logic: allow same-day anchor
        const candidateDate = new Date(baseDate.setDate(baseDate.getDate() + daysToAdd));
        const isSameUtcDay = lastPayoutCreatedAtUtc &&
            candidateDate.getUTCFullYear() === lastPayoutCreatedAtUtc.getUTCFullYear() &&
            candidateDate.getUTCMonth() === lastPayoutCreatedAtUtc.getUTCMonth() &&
            candidateDate.getUTCDate() === lastPayoutCreatedAtUtc.getUTCDate();
        if (isSameUtcDay) {
            candidateDate.setDate(candidateDate.getDate() + 7);
        }
        candidateDate.setHours(12, 0, 0, 0);
        return candidateDate;
    }
    if (interval === PayoutInterval.Daily) {
        return new Date(date.setDate(date.getDate() + 1));
    }
};
const STRIPE_PAYMENT_METHOD = [
    "card",
    "acss_debit",
    "us_bank_account",
    "sepa_debit",
    "apple_pay",
    "google_pay",
    "cashapp",
];
export const PAYMENT_METHOD_FROM_STRIPE = {
    card: PaymentMethod.Card,
    acss_debit: PaymentMethod.Pad,
    us_bank_account: PaymentMethod.Ach,
    sepa_debit: PaymentMethod.Sepa,
    apple_pay: PaymentMethod.ApplePayOrGooglePay,
    google_pay: PaymentMethod.ApplePayOrGooglePay,
    cashapp: PaymentMethod.CashApp,
};
export const isStripePaymentMethod = (pm) => {
    return STRIPE_PAYMENT_METHOD.includes(pm);
};
export const TIPPABLE_PAYMENT_METHODS = [
    PaymentMethod.Card,
    PaymentMethod.ApplePayOrGooglePay,
    PaymentMethod.Ach,
    PaymentMethod.Pad,
    PaymentMethod.Sepa,
    PaymentMethod.CashApp,
];
export const isTippablePaymentMethod = (pm) => pm !== null && pm !== undefined && TIPPABLE_PAYMENT_METHODS.includes(pm);
export const OFFLINE_PAYMENT_METHODS = [PaymentMethod.Cheque, PaymentMethod.Cash];
export const isOfflinePaymentMethod = (pm) => pm !== null && pm !== undefined && OFFLINE_PAYMENT_METHODS.includes(pm);
const PAYABLE_STRIPE_EXTERNAL_ACCOUNT_STATUSES = ["new", "validated", "verified"];
export const getBankAccountStatusFromStripeStatus = (stripeExternalAccountStatus) => {
    if (!stripeExternalAccountStatus) {
        return BankAccountStatus.Verified;
    }
    return PAYABLE_STRIPE_EXTERNAL_ACCOUNT_STATUSES.includes(stripeExternalAccountStatus)
        ? BankAccountStatus.Verified
        : BankAccountStatus.Errored;
};
